import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import { getCustomerV2 } from 'utils/CustomersAPIUtils';
import ShipperSettings from 'components/modules/user/shipper/ShipperSettings';
import StopDocumentRequirements from 'components/modules/user/shipper/StopDocumentRequirements';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';

const StopDocumentRequirementsPage = () => {
  const { t } = useTranslation();
  const params = useParams();
  const id = params.id;
  const [user, setUser] = useState();

  async function fetchUser() {
    const user = await getCustomerV2(id);
    setUser(user);
  }

  useEffect(() => {
    fetchUser();
  }, []);

  function renderSidebar() {
    return (
      <ShipperSettings activePage="stop-document-requirements" userId={id} />
    );
  }

  const breadcrumbs = {
    pages: [
      {
        name: user?.company_name || t('SHIPPER'),
        href: `/users/${id}`,
        current: false,
      },
      {
        name: t('STOP_DOCUMENT_REQUIREMENTS'),
        href: `/users/${id}/settings/stop-document-requirements`,
        current: true,
      },
    ],
  };
  // TODO: REMOVE AccessorialRequests
  return (
    <LayoutWithSidebar
      title={t('STOP_DOCUMENT_REQUIREMENTS')}
      sidebar={renderSidebar}
      breadcrumbs={breadcrumbs}
      className="py-4"
    >
      <div className="w-full">
        {featureEnabled(CONFIGURED_FEATURES.SSR) && (
          <StopDocumentRequirements id={id} />
        )}
      </div>
    </LayoutWithSidebar>
  );
};

export default StopDocumentRequirementsPage;
